<app-alert></app-alert>

<section class="card">
  <div class="card-header">
    <span class="cat__core__title">
      <strong>Allottees List</strong>
    </span>
    <span style="float:right">
      <button type="button" class="btn btn-sm btn-primary" [appHasPermission]="{'Url': '/ncd-allottees-Library/add', 'method':'post', 'menu': 'Allottees Library'}" (click)="loadNcdAllotteesByID(null, 'createNew');">
        <i class="fa fa-plus"></i> Create New Allottee</button>

      &nbsp;&nbsp;
      <button type="button" class="btn btn-sm btn-primary pull-right" [appHasPermission]="{'Url': '/ncd-allottees-Library/add', 'method':'post', 'menu': 'Allottees Library'}" data-toggle="modal" data-target="#CsvUpload">EXCEL
        File Upload </button>

    </span>
  </div>

  <section class="card search-box">
    <div class="card-header" (click)="toggleSearchDiv()"  style="cursor: pointer;">Modify Search
      <span class="pull-right">
        <i class="fa fa-filter" aria-hidden="true"></i>
      </span>
    </div>
    <div class="card-block collapse" id="search-div" [ngClass]="{'collapse': !isSearchDivVisible}">
      <div class="row">
        <div class="col-lg-12">
          <form>
            <div class="row" style="margin-bottom: 10px;">

              <div class="col-sm-2">
                <label class="form-control-label">Investor Code :</label>
                <div class="input-group">
                  <select class="form-control" id="financialYr" style="padding:6px;" name="investorCode"
                    [(ngModel)]="investorCodeModel">
                    <option value="">Select</option>
                    <option *ngFor="let investorCode of InvestorCodesList" value="{{investorCode}}">{{investorCode}}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-sm-2">
                <label class="form-control-label">Name :</label>
                <div class="input-group">
                  <input type="text" class="form-control" [(ngModel)]="nameModel" name="name" />
                </div>
              </div>

              <div class="col-sm-2">
                <label class="form-control-label">Investor Category :</label>
                <div class="input-group">
                  <input type="text" class="form-control" [(ngModel)]="investorCategoryModel" name="investorCategory" />
                </div>
              </div>

              <div class="col-sm-2">
                <label class="form-control-label">Investor Subcategory :</label>
                <div class="input-group">
                  <input type="text" class="form-control" [(ngModel)]="investorSubcategoryModel"
                    name="investorSubCategory" />
                </div>
              </div>

              <div class="col-sm-2">
                <label class="form-control-label">DP Type :</label>
                <div class="input-group">
                  <input type="text" class="form-control" [(ngModel)]="dpTypeModel" name="dpType" />
                </div>
              </div>


              <div class="col-sm-2">
                <label class="form-control-label">DP Id :</label>
                <div class="input-group">
                  <input type="text" class="form-control" [(ngModel)]="dpIdModel" name="dpId" />
                </div>
              </div>


              <div class="col-sm-2">
                <label>&nbsp;&nbsp;&nbsp;</label>
                <div class="input-group">
                  <button type="button" class="btn btn-sm btn-primary mb-2" (click)="doAdvSearch()">
                    <i class="fa fa-search"></i>Search</button>
                  &nbsp;&nbsp;&nbsp;
                  <button type="button" class="btn btn-sm btn-default mb-2" (click)="clearAdvSearch()">
                    <i class="fa fa-refresh"></i>Clear</button>
                </div>
              </div>

            </div>
          </form>
        </div>
      </div>
    </div>
  </section>

  <div class="card-block datatable-card-block">
    <div class="row">
      <div class="col-md-12">
        <div class="margin-bottom-50">
          <div class="table-responsive">
            <!-- <pre> {{termsheetArray  | json  }} </pre>
           

                <span *ngFor="let termsheet of termsheetArray; let j = index;">{{termsheet | json }}</span> -->

            <table datatable [dtOptions]="dtAllotteesList" [dtTrigger]="dtTrigger"
              class="table table-hover compact cell-border nowrap stripe" id="allotteesListTable"
              style="cursor: pointer;">
              <thead>
                <tr>
                  <th>Sr No</th>
                  <th>Investor Code</th>
                  <th>Name</th>
                  <th>Address Line 1</th>
                  <th>Line 2</th>
                  <th>Line 3</th>
                  <th>City</th>
                  <th>State</th>
                  <th>Country</th>
                  <th>Pincode</th>
                  <th>Email</th>
                  <th>Mobile</th>
                  <th>PAN</th>
                  <th>Investor Category</th>
                  <th>Investor Subcategory</th>
                  <th>Bank Name</th>
                  <th>IFSC</th>
                  <th>Virtual Account No</th>
                  <th>DP Type</th>
                  <th>DP Id</th>
                  <th>Ben/Cli Id</th>
                  <th><span>Action</span></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let allotteesList of ncdAllotteeMasterList; let i = index;" style="line-height: 25px;">
                  <td tabindex="1">{{allotteesList.srNo}}</td>
                  <td tabindex="1">{{allotteesList.investorCode}}</td>
                  <td tabindex="1">{{allotteesList.name}}</td>
                  <td tabindex="1">{{allotteesList.addressLine1}}</td>
                  <td tabindex="1">{{allotteesList.addressLine2}}</td>
                  <td tabindex="1">{{allotteesList.addressLine3}}</td>
                  <td tabindex="1">{{allotteesList.city}}</td>
                  <td tabindex="1">{{allotteesList.state}}</td>
                  <td tabindex="1">{{allotteesList.country}}</td>
                  <td tabindex="1">{{allotteesList.pinCode}}</td>
                  <td tabindex="1">{{maskEmail(allotteesList.email)}}</td>
                  <td tabindex="1">{{allotteesList.mobile}}</td>
                  <td tabindex="1">{{allotteesList.PAN}}</td>
                  <td tabindex="1">{{allotteesList.investorCategory}}</td>
                  <td tabindex="1">{{allotteesList.investorSubCategory}}</td>
                  <td tabindex="1">{{allotteesList.bankName}}</td>
                  <td tabindex="1">{{allotteesList.IFSC}}</td>
                  <td tabindex="1">{{allotteesList.virtualAccountNo}}</td>
                  <td tabindex="1">{{allotteesList.dpType}}</td>
                  <td tabindex="1">{{allotteesList.dpID}}</td>
                  <td tabindex="1">{{allotteesList.benCliId}}</td>
                  <td style='white-space: nowrap !important'>
                    <button type="button" class="btn-sm btn btn-warning"  [appHasPermission]="{'Url': '/ncd-allottees-Library/edit', 'method':'put', 'menu': 'Allottees Library'}" id="{{allotteesList._id}}"
                      (click)="loadNcdAllotteesByID(allotteesList._id, 'update')">
                      <span class="fa fa-pencil"></span>
                    </button>&nbsp;&nbsp;
                    <button type="button" class="btn-sm btn btn-danger" [appHasPermission]="{'Url': '/ncd-allottees-Library/delete', 'method':'delete', 'menu': 'Allottees Library'}" (click)="confirmDelete(allotteesList._id,allotteesList.investorCode)">
                      <span class="icmn-bin"></span>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Delete Modal -->
  <div class="modal fade" id="confirmDeleteAllottee" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
    style="top: 50px;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabelForDelete">
            <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              Are you sure you want to delete Allottee?
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-danger" (click)="deleteNcdAllotteesFromMaster()"
            data-dismiss="modal">
            <i class="fa fa-check"></i>Yes
          </button>
          <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
            <i class="fa fa-times"></i>No
          </button>
        </div>
      </div>
    </div>
  </div>


  <div class="modal" id="CsvUpload" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
    aria-labelledby="" aria-hidden="true" style="top: 50px;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            Upload Excel File</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              <div class="input-group" style="margin-left: 5px;" title="Download Format File">
                <a href=".././../../../assets/format_files/Allotte Master Upload Format File.xlsx"
                  class="btn btn-sm btn-primary">Download Format File
                  <span class="fa fa-download"></span>
                </a>
              </div>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col-sm-12">
              <input type="file" id="fileInput" accept=".xlsx" class='form-control' (change)="fileChanged($event)">
              <span style="color: red" *ngIf="fileSizeError">File size is greater than 2MB</span>
              <span style="color: red" *ngIf="fileExtensionError">Please upload excel file only.</span>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" (click)="upload()" [disabled]="isUploadNotValid" class="btn btn-sm btn-primary"
            data-dismiss="modal">
            Upload</button>
          <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
            <i class="fa fa-times"></i>&nbsp;Cancel</button>
        </div>
      </div>
    </div>
  </div>


  <div class="modal" id="notInsertdata" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
    aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog  modal-lg" role="document" style="max-width: 97% !important;">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabelForDeletion">
            Below Records are not uploaded</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="fa fa-times"></i>
          </button>

        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">

              <table datatable [dtOptions]="dtnotInsertdata" [dtTrigger]="dtnotInsertdataTrigger"
                class="table table-hover compact cell-border nowrap stripe" id="CsvUploadtable"
                style="cursor: pointer;">
                <thead>
                  <tr>
                    <th style="min-width: 200px">Error Messages</th>
                    <th>Sr. No</th>
                    <th>Investor Code<span style="color: red">*</span></th>
                    <th>Name <span style="color: red">*</span></th>
                    <th>Address Line </th>
                    <th>Line 2</th>
                    <th>Line 3</th>
                    <th>City</th>
                    <th>State</th>
                    <th>Country</th>
                    <th>Pin Code</th>
                    <th>Email</th>
                    <th>Mobile</th>
                    <th>PAN</th>
                    <th>Investor Category</th>
                    <th>Investor Subcategory</th>
                    <th>Bank Name</th>
                    <th>IFSC</th>
                    <th>Virtual Account No</th>
                    <th>DP Type</th>
                    <th>DP Id</th>
                    <th>Ben/Cli Id</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let notinserted of notinserteddata; let count=index" style="line-height: 25px;">
                    <td style="min-width: 200px">
                      <li *ngFor="let msg of notinserted.error_msg">
                        <span>{{msg}}</span>
                      </li>
                    </td>        
                    <td tabindex="1">{{ notinserted.srNo }}</td>
                    <td tabindex="1">{{ notinserted.investorCode }}</td>
                    <td tabindex="1">{{ notinserted.name }}</td>
                    <td tabindex="1">{{notinserted.addressLine1 }}</td>
                    <td tabindex="1">{{notinserted.addressLine2 }}</td>
                    <td tabindex="1">{{notinserted.addressLine3 }}</td>
                    <td tabindex="1">{{notinserted.city }}</td>
                    <td tabindex="1">{{notinserted.state }}</td>
                    <td tabindex="1">{{notinserted.country }}</td>
                    <td tabindex="1">{{notinserted.pinCode }}</td>
                    <td tabindex="1">{{maskEmail(notinserted.email)}}</td>
                    <td tabindex="1">{{notinserted.mobile }}</td>
                    <td tabindex="1">{{notinserted.PAN | uppercase}}</td>
                    <td tabindex="1">{{notinserted.investorCategory }}</td>
                    <td tabindex="1">{{notinserted.investorSubCategory }}</td>
                    <td tabindex="1">{{notinserted.bankName }}</td>
                    <td tabindex="1">{{notinserted.IFSC }}</td>
                    <td tabindex="1">{{notinserted.virtualAccountNo }}</td>
                    <td tabindex="1">{{notinserted.dpType }}</td>
                    <td tabindex="1">{{notinserted.dpID }}</td>
                    <td tabindex="1">{{notinserted.benCliId }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="modal-footer">

          <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
            <i class="fa fa-times"></i>Ok</button>
        </div>
      </div>
    </div>
  </div>
</section>